import { useTypedSelector } from "../store";

export interface IRecaptchaGate {
    /** reCaptcha is enforced: the kill-switch flag is on AND the service loaded successfully. */
    required: boolean;
    /**
     * reCaptcha is skipped — either turned off via the `VITE_FEATURE_RECAPTCHA` kill switch or
     * detected unavailable at startup. When true, forms hide the widget and drop the token from
     * their submit gate so users are not hard-blocked.
     */
    bypassed: boolean;
}

/**
 * NG-7512: shared gate for the four public registration forms. Centralizes the "should we
 * require reCaptcha right now?" decision so each form only has to branch on `bypassed`.
 */
export const useRecaptchaGate = (): IRecaptchaGate => {
    const flagEnabled = useTypedSelector((state) => state.uiSliceReducer.featureFlags.recaptcha);
    const status = useTypedSelector((state) => state.recaptchaStatusReducer.status);

    const bypassed = !flagEnabled || status === "unavailable";

    return { required: !bypassed, bypassed };
};
